import { render, staticRenderFns } from "./SlideHeader.vue?vue&type=template&id=3599c1ff&"
import script from "./SlideHeader.vue?vue&type=script&lang=ts&"
export * from "./SlideHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports